import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { Dashboard } from './../layouts'
import {
    ActionDelete,
    ActionNewButton,
    ActionUpdateButton,
    BaseTable,
    BaseTableActions
} from './../components'
import { pathJoin } from './../utils/helpers'

const columns = [
    {
        name: 'name',
        title: 'Нэр'
    },
    {
        name: 'created',
        title: 'Үүсгэсэн'
    },
    {
        name: 'updated',
        title: 'Шинэчилсэн'
    },
    {
        getCellValue: ({ id }) => <ActionUpdateButton path={pathJoin('attractions', id)} />
    }
]

const dateColumns = [
    'created', 'updated'
]

export default class Attractions extends Component {
    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    fetchData = () => {
        return this.table.current.fetchData()
    }

    render() {
        return (
            <Dashboard title="Attractions">
                <BaseTableActions>
                    <Grid item>
                        <ActionNewButton path="/attractions/new" />
                    </Grid>
                    <Grid item>
                        <ActionDelete
                            path="/attractions/mass/destroy"
                            onDelete={this.fetchData}
                        />
                    </Grid>
                </BaseTableActions>
                <BaseTable
                    path="attractions"
                    columns={columns}
                    dateColumns={dateColumns}
                    innerRef={this.table}
                />
            </Dashboard>
        )
    }
}